var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"snapshots-item",class:{ 'snapshots-item--selected': _vm.selected },attrs:{"data-test-id":"snapshots-item"},on:{"click":function($event){return _vm.$emit('click', _vm.snapshot)}}},[_c('span',{staticClass:"snapshots-item__title"},[_vm._v(_vm._s(_vm.snapshot.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }